// Copyright (c) Bentley Systems, Incorporated. All rights reserved.

export enum MapLayersSyncUiEventId {
  /** The display style settings map imagery has changed. */
  MapImageryChanged = "mapimagerychanged",
}
